import { useEffect, useState } from "react";
import { Sun, Moon, Menu, X } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import { motion } from "framer-motion";

import LogoLight from "../../Assets/logo/Asset 2@4x.png";
import LogoDark from "../../Assets/logo/Asset 10@4x.png";

export default function Navbar() {
  const [dark, setDark] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [dark]);

  return (
    <motion.nav
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="fixed top-0 w-full z-50 backdrop-blur-xl
      bg-white/80 dark:bg-[#050816]/80
      border-b border-black/5 dark:border-white/10"
    >
      {/* 🔥 Fixed Height Navbar */}
      <div className="max-w-7xl mx-auto px-6 h-16 flex justify-between items-center">

        {/* Logo (Bigger but Controlled) */}
        <Link to="/" className="flex items-center group">
          <img
            src={dark ? LogoDark : LogoLight}
            alt="360Support Logo"
            className="h-12 w-auto object-contain
            transition-all duration-300
            group-hover:scale-105"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium">
          {["about", "careers", "contact"].map((item) => (
            <NavLink
              key={item}
              to={`/${item}`}
              className={({ isActive }) =>
                isActive
                  ? "text-blue-600"
                  : "text-slate-700 dark:text-slate-300 hover:text-blue-600 transition"
              }
            >
              {item.charAt(0).toUpperCase() + item.slice(1)}
            </NavLink>
          ))}

          <button
            onClick={() => setDark(!dark)}
            aria-label="Toggle theme"
            className="p-2 rounded-full
            bg-black/5 dark:bg-white/10
            hover:scale-110 transition"
          >
            {dark ? (
              <Sun size={18} className="text-yellow-500" />
            ) : (
              <Moon size={18} className="text-slate-700" />
            )}
          </button>
        </div>

        {/* Mobile Button */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-slate-800 dark:text-white"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden px-6 pb-6 flex flex-col gap-4 text-sm font-medium bg-white dark:bg-[#050816]">
          <NavLink to="/" onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
          <NavLink to="/careers" onClick={() => setOpen(false)}>Careers</NavLink>
          <NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>

          <button
            onClick={() => setDark(!dark)}
            className="flex items-center gap-2 mt-2"
          >
            {dark ? <Sun size={16} /> : <Moon size={16} />}
            Toggle Theme
          </button>
        </div>
      )}
    </motion.nav>
  );
}